//new code START
var slidePos = 0;
var jewelFace = "Front";
var jewelColor = '14K Yellow Gold';
var jewelDate = 'Yellow';
var jewelColorID = 'Yellow';
var dateFormat = 'US';
var jewelLength = 'Short';
var printDate = "";
var printJewel = "14K Yellow Gold"
var isMobile = false; //initiate as false
var map = null;
var cellPosition;
var totalWeeks;

// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  isMobile = true;
}

isMobile = navigator.userAgentData?.mobile ?? /Mobi|Android|iPhone|iPod/i.test(navigator.userAgent);
isMobile = (/Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) || navigator.userAgentData?.mobile) && window.innerWidth < 925;

$('.hiddenSelectClose').click(function () {
  $('.hiddenSelect').hide();
});

var slidePos = 0;
$('.rightSlide').click(function () {
  if (isMobile) {
    var winWid = $('.bottom-slide-mobile').height();
    //$('.slide-inner-div').scrollLeft(winWid);
    var ll = $('.slide-inner-div').scrollLeft();
    $('.slide-inner-div').animate({ scrollLeft: ll + ((winWid + 1) * 2) }, 250);

    return false;
  }
  var slideWidth = $('.scrollable-slide').width();
  var winWidth = $(window).width();
  var extra = (slideWidth - winWidth) * (-1);

  //console.log("winWidth",winWidth);
  //console.log("slideWidth",slideWidth);

  //console.log("extra",extra);

  slidePos = slidePos - 300;

  if (slidePos < extra) {
    slidePos = extra;
    $(this).hide();
  }

  $('.leftSlide').show();
  $('.scrollable-slide').css({ "transform": "translateX(" + slidePos + "px)" });
});
$('.leftSlide').click(function () {
  slidePos = slidePos + 300;

  if (slidePos >= 0) {
    slidePos = 0;
    $(this).hide();
  }

  $('.rightSlide').show();
  $('.scrollable-slide').css({ "transform": "translateX(" + slidePos + "px)" });
});
$(document).on('click', '.popSlideClose', function () {
  $('.myPopUpOuterS').hide();
});

$('.san-one-half').click(function () {
  jewelColor = $(this).attr('data-id');
  jewelColorID = $(this).attr('data-id');
  printJewel = $(this).attr('data-txt');

  $('.color_pro_txt').html(meterialDesc[jewelColor]);
  var myClass = jewelColor.toLowerCase();  

  //$('#map-compare-container').removeClass('yellow white silver');
  //$('#map-compare-container').addClass(myClass);  

  $('.preview-main-div').removeClass('yellow white silver');
  $('.preview-main-div').addClass(myClass);

  $('.san-desk-h2[data-id="a2"]').html($(this).attr('data-txt'));
  
  if(jewelColor == 'Yellow') {
    jewelColor = '14K Yellow Gold';
    $("#productSelect-option-0").val("14K Gold").trigger('change');
  } else if(jewelColor == 'White') {
    jewelColor = '14K White Gold';
    $("#productSelect-option-0").val("14K Gold").trigger('change');
  } else if(jewelColor == 'Silver') {
    jewelColor = '925 Sterling Silver';
    $("#productSelect-option-0").val("925 Sterling Silver").trigger('change');
  } 

  $('.san-one-half').removeClass('san-one-half-hover');
  $(this).addClass('san-one-half-hover');  
  
  setFormVars(map, 3);  
});
$(document).mouseup(function (e) {
  //close slideshow popup
  var container = $(".myPopUpInnerS");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.myPopUpOuterS').hide();
  }
});


$('.san-txt-div-bot').click(function () {
  jewelLength = $(this).attr('data-id');
  $('.san-txt-div-bot').removeClass('san-txt-div-bot-hover');
  $(this).addClass('san-txt-div-bot-hover');
  //$("#productSelect-option-1").val(jewelLength).trigger('change');
  $('.san-desk-h2[data-id="a3"]').html(jewelLength);

  $('.chain_length_pro_txt').html('<span class="pro-bold">Short: 17.5in (45cm) / </span>Medium: 23.5in (60cm).<br>Type: 0.5mm Box Chain');
  if (jewelLength == 'Medium') {
    $('.chain_length_pro_txt').html('Short: 17.5in (45cm)<span class="pro-bold"> / Medium: 23.5in (60cm).</span><br>Type: 0.5mm Box Chain');
  }

  setFormVars(map, 5);
});

$('.select-date-format').change(function () {
  dateFormat = $(this).val(); 
  backSideDate();
  $('.preview-toggle-btn[data-id="2"]').trigger('click');
});

$('.preview-toggle-btn').on('click', function (e) {
  $('.preview-toggle-btn').removeClass('selected');
  $(this).addClass('selected');
  var id = $(this).attr('data-id');
  $('.front-out').hide();
  $('.front-out[data-id="'+id+'"]').show();  
  backSideDate();

  $('#map-compare-container').removeClass('front back');
  
  if(id == 2) {    
    $('#map-compare-container').addClass('back');
  } else {
    $('#map-compare-container').addClass('front');
  }
});
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////

showHideSlideImages('All');

var meterialDesc = {
  Gold: "24K gold-plated brass with a matte finish, designed for everyday elegance.",
  Vermeil: "Sterling silver coated with a thick layer of 18K vermeil gold, durable and perfect for everyday wear.",
  Yellow: "14k yellow gold will not oxidize or discolor, so you can wear your jewelry every day.",
  Palladium: "Palladium-plated brass with a matte finish, designed for everyday elegance.",
  Silver: "A precious metal alloy made of 92.5% pure silver, it's designed for everyday wear and highly durable.",
  White: "14k white gold will not oxidize or discolor, so you can wear your jewelry every day."
};


var varDiscount = {
    "Silver": 20,
    "Yellow": 10,
    "White": 10
  };



$(document).mouseup(function (e) {  
  var container = $(".myPopUpInnerS");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.myPopUpOuterS').hide();
  }
});

$('.closePopUpOuterS').click(function () {
  $('.myPopUpOuterS').hide();
});
$('.close-size-guide').click(function () {
  $('.size_guide').hide();
});
$('.size-giude-link').click(function () {
  $('.size_guide').show();
});

function backSideDate() {
  $('.san-desk-h2[data-id="a4"]').html(dateFormat);
  var format = (dateFormat == 'US')?"MM.DD.YYYY":"DD.MM.YYYY";
  var date = new Date($('#datepicker').val());
  $('.back-view-date').html(formatBackSideDate(date, format));
  
  //divPosition();
  setFormVars(map,8);
}

function showHideSlideImages(typsIn) {
  if (typsIn == 'All') {
    $('.slide-imgs').addClass('show-slide');
    return;
  }
  $('.slide-imgs').removeClass('show-slide');
  $.each(slideImgArr[typsIn], function (key, val) {
    $('.slide-imgs[data-id="' + val + '"]').addClass('show-slide');
  });
}

$('.rightSlide').click(function () {
  if (isMobile) {
    var winWid = $('.bottom-slide-mobile').height();    
    var ll = $('.slide-inner-div').scrollLeft();
    $('.slide-inner-div').animate({ scrollLeft: ll + ((winWid + 1) * 2) }, 250);

    return false;
  }
  var slideWidth = $('.scrollable-slide').width();
  var winWidth = $(window).width();
  var extra = (slideWidth - winWidth) * (-1);

  slidePos = slidePos - 300;

  if (slidePos < extra) {
    slidePos = extra;
    $(this).hide();
  }

  $('.leftSlide').show();
  $('.scrollable-slide').css({ "transform": "translateX(" + slidePos + "px)" });
});

$('.leftSlide').click(function () {
  slidePos = slidePos + 300;

  if (slidePos >= 0) {
    slidePos = 0;
    $(this).hide();
  }

  $('.rightSlide').show();
  $('.scrollable-slide').css({ "transform": "translateX(" + slidePos + "px)" });
});

$(document).on('click', '.popSlideClose', function () {
  $('.myPopUpOuterS').hide();
});

var indexOfElem = 0;
$('.slide-imgs').click(function () {
  indexOfElem = $('.slide-imgs').index(this);
  var img = $(this).find('img').attr('src');
  $('.popUpImgSrc').attr('src', img);
  $('.myPopUpOuterS').show();
});

$(document).on('click', '.rightSlidePop', function () {
  var len = $('.show-slide').length;
  indexOfElem++;

  if (indexOfElem > (len - 1)) {
    indexOfElem = 0;
  }

  var img = $('.show-slide').eq(indexOfElem).find('img').attr('src')
  $('.popUpImgSrc').attr('src', img);
});

$(document).on('click', '.leftSlidePop', function () {
  var len = $('.show-slide').length;
  indexOfElem--;

  if (indexOfElem < 0) {
    indexOfElem = len - 1;
  }

  var img = $('.show-slide').eq(indexOfElem).find('img').attr('src')
  $('.popUpImgSrc').attr('src', img);
});

function getExternalData(mapid) {
  $.ajax({
    url: 'https://tsbackoffice.com/tsbackoffice/decode_mapid.php',
    method: 'get',
    data: { mapid: mapid },
    success: function (response) {      
      window.location.href = response.url;
    }
  });
}

$(document).ready(function () {
  preLoadImages(); // Assuming this exists in your code
  const today = new Date();
  
  $("#datepicker").datepicker("setDate", today);
  $('#datepicker').trigger('change');
  
  var txt = '<div class="myPopUpOuterS">';
  txt += '<div class="myPopUpInnerS">';
  txt += '<div class="myPOpUpImgCont"><img src="https://cdn.shopify.com/s/files/1/1157/3696/products/img3_1024x1024.png?v=1623999553" class="popUpImgSrc"></div>';
  txt += '<div class="poparr leftSlidePop"> <div class="in-arr"></div> </div>';
  txt += '<div class="poparr rightSlidePop"> <div class="in-arr"></div> </div>';
  txt += '<div class="popSlideClose"></div>';
  txt += '</div>';
  txt += '</div>';

  $('body').append(txt);

  if (isMobile) {
    //$('.san-desktop-version,#inp-outer-desk').remove();
    var ht = $(window).width();

    $('.myPopUpInnerS').css({ "height": ht + "px" });
    ht = (ht * 40) / 100;
    $('.bottom-slide').css({ "height": ht + "px" });
  } else {
    //$('.pac-input-div,.loc-temp,#inp-outer-mob').remove();
  } 

  resizeMapContainer();
  
  $('.product-page,.wrapper').show(); 
  divPosition();
  setFormVars(map,314); 

  if(isMobile){
    //set top
    var h1 = $('.announcement__wrapper').height();
    var h2 = $('.show-slide').height();
    var h3 = $('.header__mobile').height();
    var top = h1+h2+h3;
    $('.abs-section').css({"top":top+"px"})
  }
});

$(window).resize(function () {
  resizeMapContainer();
});

function resizeMapContainer() {
  var ht = $(window).height();
  var newHT = ht - 98;
}

$("#AddToCart-product").click(function() {    
  	//setFormVars(map,77);  	

    var $loader = $(this).find('.loader');
  if ($loader.length > 0) {
    $(this).find('span').addClass('hidden');
    $loader.removeClass('hidden');
  }
  
});

/////////////////////////////////
//////////////////////////

function setFormVars(map, origins) {  
  $("#my_color").val(jewelColor);
  $("#my_date").val(jewelDate);
  $("#my_date_format").val(dateFormat);
  $("#my_chain_length").val(jewelLength); 
  $('#my_cell_position').val(cellPosition); 
  $('#my_total_weeks').val(totalWeeks);

  $('#my_print_date').val(printDate); 
  $('#my_print_jewel').val(printJewel); 

  //console.log('jewelColor',jewelColor);
  //console.log('jewelDate',jewelDate);
  //console.log('dateFormat',dateFormat);
  //console.log('jewelLength',jewelLength);
  //console.log('cellPosition',cellPosition);
  

  setTimeout(function() {    
    var dis = varDiscount[jewelColorID];    
    console.log('jewelColor',jewelColor);
    var compPrice = parseInt($('.buttonPrice').attr('data-item-base-price'));
    var basePrice = Math.round(compPrice-((compPrice*dis)/100));
    var finaPrice = compPrice - basePrice;
  
    if(isNaN(finaPrice)) {
      finaPrice = 0;
    }
    if(isNaN(compPrice)) {
      compPrice = 0;
    }
    if(isNaN(basePrice)) {
      basePrice = 0;
    }
    
    $('.save-price-dis-amt').html('$'+parseFloat((finaPrice/100)).toFixed(2));
    $('.save-price-org').html('$'+parseFloat((basePrice/100)).toFixed(2));
    $('.save-price-com').html('$'+parseFloat((compPrice/100)).toFixed(2));
  },100)  
}

function updateLuckyOrangeOnMapChange() {
  if (!window.LO) {
    return;
  }

  if (canvasMovesSinceReport !== 25) {
    canvasMovesSinceReport += 1;
    return;
  }

  window.LO.update_canvas('canvas');
  canvasMovesSinceReport = 0;
}

function formatBackSideDate(date, format = "DD.MM.YYYY") {
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits (Months are 0-based)
  const year = date.getFullYear();

  if (format === "DD.MM.YYYY") {
    return `${day}.${month}.${year}`;
  } else if (format === "MM.DD.YYYY") {
    return `${month}.${day}.${year}`;
  } else {
    throw new Error("Invalid format! Use 'DD.MM.YYYY' or 'MM.DD.YYYY'");
  }
}
function formatDate(date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}
function formatInputDate(date) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}
function formatToJewelDate(date) {
  const d = date;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day} 00:00:00`;
}

function divPosition() {
  var $parent = $('.front-view-marker-out');
  var wid = $parent.innerWidth();
  var hig = 66; // Fixed container height

  var markerWidth = wid / 7;
  var selectedDate = new Date($('#datepicker').val());

  if (isNaN(selectedDate.getTime())) {
    console.error("Invalid date selected. Please choose a valid date.");
    return;
  }

  jewelDate = formatToJewelDate(selectedDate);
  $('.san-desk-h2[data-id="a5"]').html($('#datepicker').val());
  $('.preview-date').text(formatDate(selectedDate));
  var format = (dateFormat == 'US') ? "MM.DD.YYYY" : "DD.MM.YYYY";
  $('.back-view-date').html(formatBackSideDate(selectedDate, format));
  printDate = formatBackSideDate(selectedDate, format);

  var dayOfMonth = selectedDate.getDate();
  var dayOfWeek = selectedDate.getDay();
  var year = selectedDate.getFullYear();
  var month = selectedDate.getMonth();
  var firstDayOfMonth = new Date(year, month, 1).getDay();
  var totalDaysInMonth = new Date(year, month + 1, 0).getDate();

  var isMondayStart = false;
  if (isMondayStart) {
    firstDayOfMonth = (firstDayOfMonth === 0) ? 6 : firstDayOfMonth - 1;
    dayOfWeek = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
  }

  var totalCells = firstDayOfMonth + totalDaysInMonth;
  var totalWeeks = Math.ceil(totalCells / 7);

  var rowHeight = 10;
  var spaceBetweenRows = (66 - (rowHeight * totalWeeks)) / (totalWeeks - 1);

  $('.front-view-marker').css({
    "width": "14px",
    "height": "14px"
  });

  var adjustedDay = dayOfMonth + firstDayOfMonth - 1;
  var weekNumber = Math.floor(adjustedDay / 7);

  var baseCharCode = 65; // 'A'
  if (totalWeeks === 6) {
    baseCharCode = 72; // 'H'
  }
  var columnLetter = String.fromCharCode(baseCharCode + dayOfWeek);
  var rowNumber = weekNumber + 1;
  cellPosition = columnLetter + rowNumber;
  console.log('cellPosition', cellPosition);

  var topPosition = weekNumber * (rowHeight + spaceBetweenRows);
  var position = {
    top: Math.min(topPosition, hig - rowHeight),
    left: Math.min(dayOfWeek * markerWidth, wid - markerWidth)
  };

  $('.front-view-marker').css(position);
  $('.front-view-marker').removeClass('fourrows fiverows sixrows');
  if (totalWeeks === 6) {
    $('.front-view-marker').addClass('sixrows');
  } else if (totalWeeks === 5) {
    $('.front-view-marker').addClass('fiverows');
  } else if (totalWeeks === 4) {
    $('.front-view-marker').addClass('fourrows');
  }

  setFormVars();
}

function preLoadImages() { 
  const images = [
    'https://taliasari.com/cdn/shop/t/34/assets/Gold_Back_420.webp?v=1749548321',
    'https://taliasari.com/cdn/shop/t/34/assets/Silver_Front_420.webp?v=1749549048',
    'https://taliasari.com/cdn/shop/t/34/assets/Silver_Back_420.webp?v=1749549041',
    'https://taliasari.com/cdn/shop/t/34/assets/White_Front_420.webp?v=1749549064',
    'https://taliasari.com/cdn/shop/t/34/assets/White_Back_420.webp?v=1749549057',
    'https://taliasari.com/cdn/shop/t/34/assets/diamond_gold_100px.webp?v=1749552670',
    'https://taliasari.com/cdn/shop/t/34/assets/diamond_white_100px.webp?v=1749552683',
    'https://taliasari.com/cdn/shop/t/34/assets/diamond_silver_100px.webp?v=1749552677'
  ];

  images.forEach(function(src) {
    const img = new Image();
    img.src = src;
  });
}

function divPositionOld() { 
  /*********** STEP 1: GET PARENT CONTAINER DIMENSIONS ***********/
  // Select the parent container where the marker will be positioned
  var $parent = $('.front-view-marker-out');

  // Get the full width and height of the parent container
  var wid = $parent.innerWidth();
  var hig = $parent.innerHeight();

  /*********** STEP 2: DETERMINE MARKER SIZE ***********/
  // Calculate the marker's width: The container is divided into 7 columns (for 7 days in a week)
  var markerWidth = wid / 7;

  /*********** STEP 3: RETRIEVE THE SELECTED DATE FROM DATE PICKER ***********/
  // Get the value from the date picker input and convert it to a Date object
  var selectedDate = new Date($('#datepicker').val());

  // Check if the date is valid (i.e., not "Invalid Date")
  if (isNaN(selectedDate.getTime())) {
    console.error("Invalid date selected. Please choose a valid date.");
    return;  // Exit the function if the date is invalid
  }

  jewelDate = formatToJewelDate(selectedDate);

  /*********** STEP 4: UPDATE UI ELEMENTS WITH SELECTED DATE ***********/
  // Display the selected date inside an HTML element (likely for user preview)
  $('.san-desk-h2[data-id="a5"]').html($('#datepicker').val());  

  // Format the date for another UI preview area
  $('.preview-date').text(formatDate(selectedDate));
  var format = (dateFormat == 'US')?"MM.DD.YYYY":"DD.MM.YYYY";
  $('.back-view-date').html(formatBackSideDate(selectedDate, format));

  /*********** STEP 5: EXTRACT DATE COMPONENTS ***********/
  var dayOfMonth = selectedDate.getDate();   // Get the day of the month (1-31)
  var dayOfWeek = selectedDate.getDay();     // Get the day of the week (0 = Sunday, 6 = Saturday)
  var year = selectedDate.getFullYear();     // Get the full year (e.g., 2025)
  var month = selectedDate.getMonth();       // Get the month (0 = January, 11 = December)

  /*********** STEP 6: FIND THE FIRST DAY OF THE MONTH ***********/
  // Create a new date object for the 1st of the selected month and get its weekday (0-6)
  var firstDayOfMonth = new Date(year, month, 1).getDay();

  /*********** STEP 7: FIND THE TOTAL NUMBER OF DAYS IN THE MONTH ***********/
  // By setting the date to 0 of the next month, we get the last day of the current month
  var totalDaysInMonth = new Date(year, month + 1, 0).getDate();  

  /*********** STEP 8: HANDLE MONDAY-STARTED WEEKS (IF REQUIRED) ***********/
  var isMondayStart = false;  // Change this to true if weeks should start on Monday instead of Sunday
  if (isMondayStart) {
    // Adjust so that Monday = 0, Tuesday = 1, ..., Sunday = 6
    firstDayOfMonth = (firstDayOfMonth === 0) ? 6 : firstDayOfMonth - 1;
    dayOfWeek = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
  }

  /*********** STEP 9: CALCULATE THE TOTAL NUMBER OF WEEKS (ROWS) ***********/
  // Find the total number of cells required (days in the month + empty slots before the 1st)
  var totalCells = firstDayOfMonth + totalDaysInMonth;  

  // Divide by 7 (days in a week) and round up to determine the number of rows needed
  totalWeeks = Math.ceil(totalCells / 7);  

  /*********** STEP 10: CALCULATE MARKER HEIGHT BASED ON TOTAL ROWS ***********/
  // Each row represents a week, so divide the container height by the number of weeks
  var markerHeight = hig / totalWeeks;  

  /*********** STEP 11: APPLY MARKER SIZE STYLING ***********/
  $('.front-view-marker').css({
    "width": markerWidth + "px",  // Set marker width
    "height": markerHeight + "px" // Set marker height dynamically based on total rows
  });

  /*********** STEP 12: CALCULATE THE MARKER POSITION ***********/
  // AdjustedDay: How many days have passed since the start of the month (0-based index)
  var adjustedDay = dayOfMonth + firstDayOfMonth - 1;  

  // Find which row (week) this day falls in
  var weekNumber = Math.floor(adjustedDay / 7);
  /*********** STEP 13: CALCULATE THE CELL POSITION ***********/
  var baseCharCode = 65; // 'A'
if (totalWeeks === 6) {
  baseCharCode = 71; // 'G'
}
var columnLetter = String.fromCharCode(baseCharCode + dayOfWeek);

  // Row number is weekNumber + 1 (because weeks start from 1)
  var rowNumber = weekNumber + 1;

  // Combine to get position (e.g., "B3")
  cellPosition = columnLetter + rowNumber;
  console.log('cellPosition',cellPosition);
    
  /*********** STEP 14: ENSURE MARKER STAYS WITHIN CONTAINER ***********/
  var position = {
    top: Math.min(weekNumber * markerHeight, hig - markerHeight),  // Keep marker within height limits
    left: Math.min(dayOfWeek * markerWidth, wid - markerWidth)     // Keep marker within width limits
  };

  /*********** STEP 15: APPLY THE MARKER POSITION ***********/
  $('.front-view-marker').css(position); 
  $('.front-view-marker').removeClass('fourrows fiverows sixrows'); // Clear old classes  
  if (totalWeeks === 6) {
    $('.front-view-marker').addClass('sixrows');
  } else if (totalWeeks === 5) {
    $('.front-view-marker').addClass('fiverows');
  } else if (totalWeeks === 4) {
    $('.front-view-marker').addClass('fourrows');
  }

  setFormVars();
}